
export default {
  state: {
    lang: 'es'
  },
  mutations: {
    setLanguage(state,lang){
      state.lang=lang
    }
  },
  actions: {
    setLanguage(context,lang){
      localStorage.setItem("lang",lang)
      context.commit('setLanguage',lang)
    }
  }
}